const ConstructionDailyLog = {

    "construction_daily_log": "Construction Daily Log",
    "add_daily_log": "Add Daily Log",
    "project_details": "Project Details",
    "step_details": "Log Details",
    "step_review": "Review",
    "daily_work_details": "Daily Work Details",
    "daily_not_work_details": "Daily Not Work Details",

    "log_date": "Date",
    "stage": "Stage",
    "work_status": "Work Status",
    "total_labour_count": "Total Labour Count",
    "supervisor_labour_count": "Supervisor Labour Count",
    "local_labour_force_count": "Local Labour Force Count",
    "labour_media": "Total Labour Count — Photo/Video",
    "equipment_used": "Equipment Used",
    "resources_short_supply": "Resources in Short Supply",
    "resources_short_supply_other": "Resources in Short Supply (Other)",
    "work_completed_today": "Work Completed Today",
    "weather_conditions": "Weather Conditions",
    "weather_conditions_other": "Weather Conditions (Other)",
    "weather_evidence": "Weather Condition Evidence",
    "not_working_reason": "What is the reason of \"Not Working\" Today?",

    "work_status_working": "Working Today",
    "work_status_not_working": "Not Working Today",

    "next": "Next",
    "back": "Back",

    "error_log_date": "Select Date",
    "error_stage": "Select Stage",
    "error_work_status": "Select Work Status",
    "error_total_labour_count": "Enter Total Labour Count",
    "error_supervisor_labour_count": "Enter Supervisor Labour Count",
    "error_local_labour_force_count": "Enter Local Labour Force Count",
    "error_labour_media": "Upload Photo/Video",
    "error_resources_short_supply": "Select Resources in Short Supply",
    "error_work_completed_today": "Enter Work Completed Today",
    "error_weather_conditions": "Select Weather Conditions",
    "error_weather_evidence": "Upload Weather Condition Evidence",
    "error_not_working_reason": "Enter reason for not working today",
    "error_resources_other": "Enter other resource",
    "error_weather_other": "Enter other weather condition",
    "error_fill_required": "Please fill all required fields",

    "location_map": "Location Map",
    "daily_log_location": "Daily log location",
    "project_location": "Project location",
    "map_unavailable": "Location coordinates are not available for this log.",
    "map_load_error": "Unable to load interactive map. Showing static map if available.",
    "map_key_missing": "Google Maps API key is missing. Add REACT_APP_GOOGLE_MAP_KEY to .env and restart the dev server.",
    "map_latitude": "Latitude",
    "map_longitude": "Longitude",
    "map_locality": "Locality / Address",
    "map_loading_locality": "Loading locality…",
    "map_locality_unavailable": "Locality not available",

}

export default ConstructionDailyLog;
